module.exports = __webpack_public_path__ + "img/dinner.5ce8e70a.png";